import React, { useCallback, useMemo } from "react";
import { RuleReviewStatus } from "@common/types/transactionRule";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { FilterActionsFooter } from "@design-system/Filter/FilterActionsFooter/FilterActionsFooter";
import { BaseFilterProps } from "../../lib";
import {
    ReviewerFilterSection,
    useReverseReviewers,
} from "../ReviewFilter/ReviewerFilterSection";
import styles from "../ReviewFilter/ReviewFilter.module.scss";

const STATUS_OPTIONS: Array<FilterMultiselectOption<RuleReviewStatus>> = [
    { value: RuleReviewStatus.REVIEWED, label: "Reviewed" },
    { value: RuleReviewStatus.UNREVIEWED, label: "Unreviewed" },
];

export const RuleReviewFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const statuses = useMemo(
        () => filters.ruleReviewStatuses ?? [],
        [filters.ruleReviewStatuses],
    );
    const reviewerIds = useMemo(
        () => filters.ruleReviewerIds ?? [],
        [filters.ruleReviewerIds],
    );
    const reviewerMode = filters.ruleReviewerMode ?? "any";

    const isFilterActive = statuses.length > 0 || reviewerIds.length > 0;

    const handleReset = useCallback(() => {
        onChange({
            ruleReviewStatuses: undefined,
            ruleReviewerIds: undefined,
            ruleReviewerMode: undefined,
        });
    }, [onChange]);

    const handleReviewerIdsChange = useCallback(
        (ids: number[] | undefined) => onChange({ ruleReviewerIds: ids }),
        [onChange],
    );

    const reverseReviewers = useReverseReviewers({
        reviewerIds,
        onReviewerIdsChange: handleReviewerIdsChange,
    });

    return (
        <div className={styles.filter}>
            <div>
                <div className={styles.sectionTitle}>Status</div>
                <FilterMultiselect
                    inDropdown={false}
                    searchable={false}
                    options={STATUS_OPTIONS}
                    value={statuses}
                    onChange={(selectedStatuses) =>
                        onChange({
                            ruleReviewStatuses:
                                selectedStatuses.length > 0
                                    ? selectedStatuses
                                    : undefined,
                        })
                    }
                />
            </div>

            <ReviewerFilterSection
                modeName="ruleReviewerMode"
                idsName="ruleReviewerIds"
                reviewerIds={reviewerIds}
                reviewerMode={reviewerMode}
                onModeChange={(mode) => onChange({ ruleReviewerMode: mode })}
                onReviewerIdsChange={handleReviewerIdsChange}
            />
            {isFilterActive && (
                <FilterActionsFooter
                    deselectFunction={handleReset}
                    selectedCount={statuses.length + reviewerIds.length}
                    reverseFunction={reverseReviewers}
                />
            )}
        </div>
    );
};
